// extracted by mini-css-extract-plugin
export default {"wrapper":"impersonateWarningBanner_wrapper__uGP9b","inner":"impersonateWarningBanner_inner__flQ4H"};